import { PickupEventListPage } from "components/shared/pickupEvents";

export const PickupEventList: React.FC = () => (
  <PickupEventListPage variant="admin" />
);
